import { render, staticRenderFns } from "./ImportExceldemo.vue?vue&type=template&id=bb3db6f8"
import script from "./ImportExceldemo.vue?vue&type=script&lang=js"
export * from "./ImportExceldemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports